import React, { useState } from "react";
import get from "lodash/get";

import CommonInput from "../CommonComponent/CommonInput";

function UtilityFieldLabels(props) {
  const {
    onChange,
    idLabel,
    classesFromProps,
    name,
    value,
    onBlur,
    errors,
    touched
  } = props;
  return (
    <div className={`consumer_id ${classesFromProps || ""}`}>
      <CommonInput
        stylesContainer={{
          textAlign: "left"
        }}
        legendName={idLabel}
        onChange={onChange}
        value={value}
        name={name}
        error={get(errors, name, false) && get(touched, name, false)}
        errorMsg={get(errors, name, false)}
        touched={get(touched, name, false)}
        onBlur={onBlur}
      />
    </div>
  );
}
export default UtilityFieldLabels;
